import { IEngagements } from '../../../types/services';
import { normalizeWhiteSpace } from '../../../helpers/string';
import { POLICIES_NAME, ADDRESS_TYPE, AddressOption } from './HouseAddress';
import { getDefaultAddresses } from './getDefaultAddresses';

type POLICIES_MAPPING = [POLICIES_NAME, ADDRESS_TYPE];

export const POLICIES_MAPPINGS: POLICIES_MAPPING[] = [
    ['hus', 'HOME'],
    ['husforsikring', 'HOME'],
    ['indbo', 'HOME'],
    ['indboforsikring', 'HOME'],
    ['indboforsikring til unge', 'HOME'],
    ['fritidshus', 'COTTAGE'],
    ['fritidshus bygning', 'COTTAGE'],
    ['fritidshus u/opførelse', 'COTTAGE'],
    ['fritidshusforsikring', 'COTTAGE']
];

// CA will fail if we pass wrong policynumbers for these claims
const FORM_SUBMIT_API_POLICY_FILTERS: Record<string, POLICIES_NAME[]> = {
    'kloak-privat': ['hus', 'husforsikring'],
    'doere-og-vinduer-privat': ['hus', 'husforsikring']
};

export const getAddressesFromPolicies = (data: IEngagements | null, formSubmitApiPath: string): AddressOption[] => {
    if (!data || !('categories' in data)) {
        return [];
    }

    const options: AddressOption[] = [];
    const allowedPolicies = FORM_SUBMIT_API_POLICY_FILTERS[formSubmitApiPath]?.map((name) => name.toLowerCase()) ?? [];

    data.categories.forEach(({ products, text }) => {
        if (text.toLowerCase() !== 'bolig') {
            return;
        }
        const defaultAddress = getDefaultAddresses('showPolicyAddresses');
        products.forEach((product) => {
            const insuranceName = normalizeWhiteSpace(product.insuranceDetails.text);
            const insuranceStatus = normalizeWhiteSpace(product.insuranceDetails.status);
            const policyNumber = normalizeWhiteSpace(product.insuranceAgreementNumber);
            const policyDescription = normalizeWhiteSpace(product.insuranceDetails.description);

            const isInsuranceActive = insuranceStatus === 'IKRAFT';

            if (!isInsuranceActive) {
                return;
            }
            const policyMapping = POLICIES_MAPPINGS.find(([name]) => name === insuranceName.toLowerCase());
            if (!policyMapping) return;

            const [matchedName, buttonType] = policyMapping;

            // Only include in options if it's allowed, or no filtering applied
            const isAllowed = allowedPolicies.length === 0 || allowedPolicies.includes(matchedName);
            if (!isAllowed) return;

            // merge into one with same address
            const matchingDescription = options.findIndex((s) => s.valueOnSubmit.label === policyDescription);
            if (matchingDescription > -1) {
                options[matchingDescription] = {
                    ...options[matchingDescription],
                    valueOnSubmit: {
                        ...options[matchingDescription].valueOnSubmit,
                        policies: [
                            ...options[matchingDescription].valueOnSubmit.policies!,
                            {
                                type: insuranceName as POLICIES_NAME,
                                number: policyNumber
                            }
                        ]
                    }
                };
                return;
            }

            /*  const buttonType = POLICIES_MAPPINGS.find(
                (p: POLICIES_MAPPING) => p[0] === insuranceName.toLowerCase()
            )![1];*/
            options.push({
                ...defaultAddress,
                value: `${defaultAddress.value}-${policyDescription}`,
                label: policyDescription,
                valueOnSubmit: {
                    policies: [
                        {
                            type: matchedName as POLICIES_NAME,
                            number: policyNumber
                        }
                    ],
                    buttonType,
                    label: policyDescription
                }
            });
        });
    });

    return options;
};
